import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import { Container, Button } from 'reactstrap';
import UpdatePlcSafetyTriggerForm from '../../components/Forms/UpdatePlcSafetyTriggerForm';

class PlcSafetyTriggerDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      trigger: this.props.location.state || null,
    };
  }

  componentDidMount() {
    if (!this.state.trigger) {
      this.props.history.push('/plcSafetyTriggers');
    }
  }

  goBack(event) {
    event.preventDefault();
    this.props.history.push('/plcSafetyTriggers');
  }

  render() {
    const { trigger } = this.state;
    if (!trigger) return null;
    return (
      <div className="user-management">
        <Container fluid>
          <Button className="btn btn-primary waves-effect waves-light usersButtons" onClick={(event) => this.goBack(event)}>
            <i className="fas fa-arrow-left"></i>
          </Button>
          <UpdatePlcSafetyTriggerForm trigger={trigger} />
        </Container>
      </div>
    );
  }
}

export default withRouter(withNamespaces()(PlcSafetyTriggerDetails));
